var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',{attrs:{"name":"register","wide":"","bg-image":"","centered":"","box":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }